const PREFIX = 'TAG_';

const tagConstants = {
  TAG_REQUEST: PREFIX + 'TAG_REQUEST',
  TAG_SUCCESS: PREFIX + 'TAG_SUCCESS',
  TAG_FAILURE: PREFIX + 'TAG_FAILURE',

  SELECT_TAG: PREFIX + 'SELECT_TAG',
};

export default tagConstants;
